var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"total-time",class:{dark: _vm.isDark}},[_vm._v(_vm._s(_vm.duration))])}
var staticRenderFns = []

export { render, staticRenderFns }